import { AdBreakFilter, ListResult, SearchableFilter } from 'common/api/v1/types'
import { EdgeClient } from 'common/generated/edgeClient'

import { AdBreak } from 'common/api/v1/types'
import { AdBreaksRequestParams, singleSortQueryFromPaginatedRequestParams } from '../nm-types'

export class AdBreaksApi {
  constructor(private readonly edgeClient: EdgeClient) {}

  async listAdBreaks(params: AdBreaksRequestParams): Promise<ListResult<AdBreak>> {
    const filter = {
      searchName: params.filter,
      fromDate: params.fromDate ? new Date(params.fromDate) : undefined,
      toDate: params.toDate ? new Date(params.toDate) : undefined,
      status: params.status,
      adId: params.adId,
      eventId: params.eventId,
    } as AdBreakFilter

    const query = singleSortQueryFromPaginatedRequestParams<SearchableFilter, string>({
      filter,
      paginatedRequestParams: params,
    })
    return this.edgeClient.listAdBreaks(query)
  }

  getAdBreak(id: string): Promise<AdBreak> {
    return this.edgeClient.getAdBreak(id)
  }

  deleteAdBreak(id: string): Promise<AdBreak> {
    return this.edgeClient.deleteAdBreak(id)
  }
}
